import { useAuthStore, initializeAuth } from "@/stores/authStore";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader } from "@/components/Loader";

export function GoogleRedirectPage() {
  const navigate = useNavigate();
  const { session } = useAuthStore();

  console.log("Google Redirect Page");

  useEffect(() => {
    initializeAuth();
  }, []);

  useEffect(() => {
    if (session) {
      console.log("Session found, navigating to admin", session);
      navigate("/admin");
    }
  }, [session, navigate]);

  console.log("Session after redirect initialization", session);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <Loader />
    </div>
  );
}
